





































































































































































import ActionButton from '@/components/ActionButton.vue'
import {
  getRemittances,
  remittanceTotals,
  getRemittanceInvoicePDF,
} from '@/api/Remittances/remittances.api'
import Table from '@/components/Table.vue'
import {
  DatePicker,
  Paginator,
  Params,
  TableHeader,
  VueTable,
  VueTotal,
} from '@/utils/interfaces'
import { tableHandler } from '@/utils/mixins/tableHandler'
import { Remittance } from '@/utils/interfaces/remittance.interface'
import RemittanceFilter from '@/components/Services/Remittances/Remittance/RemittanceFilter.vue'
import { User } from '@/api/Auth/auth.interface'
import mixins from 'vue-typed-mixins'
import { reportMixin } from '@/utils/mixins/reportMixin'
import Totals from '@/components/Services/Remittances/Remittance/Totals.vue'
import { AxiosResponse } from 'axios'
import moment from 'moment'
import FlatCard from '~/components/FlatCard.vue'
import TextButton from '~/components/TextButton.vue'
import RangeDatePicker from '~/components/RangeDatePicker.vue'
import Autocomplete from '~/components/Autocomplete.vue'
import { getAgencies } from '~/api/Agency/agency.api'

export default mixins(reportMixin, tableHandler<Remittance>()).extend({
  components: {
    appActionButton: ActionButton,
    appTable: Table,
    appRemittanceFilter: RemittanceFilter,
    appRemittanceTotals: Totals,
    FlatCard,
    TextButton,
    RangeDatePicker,
    Autocomplete,
  },
  data() {
    return {
      tabs: 0,
      headers: [
        {
          text: this.$t('code'),
          value: 'code',
          sortable: false,
        },
        {
          text: this.$t('sender'),
          value: 'client_origin_name',
          sortable: false,
        },
        {
          text: this.$t('receiver'),
          value: 'client_destiny_name',
          sortable: false,
        },
        {
          text: this.$t('currency'),
          value: 'delivery_currency',
          sortable: false,
        },
        {
          text: this.$t('delivery_amount'),
          value: 'delivery_amount',
          sortable: false,
        },
        {
          text: this.$t('created-at'),
          value: 'created_at',
        },
      ],
      loadingInvoice: false,
      allAmount: false,
      thisWeek: {
        created_at__lte: moment()
          .endOf('week')
          .toISOString(),
        created_at__gte: moment()
          .startOf('week')
          .toISOString(),
      },
      filter: {
        from_agency__uuid: '',
      },
    }
  },
  computed: {
    isDark(): boolean {
      return this.$vuetify.theme.dark
    },
    computedHeaders(): TableHeader[] {
      if (this.profile.role !== 'ADMIN' || this.tabs === 0) return this.headers
      else
        return [
          {
            text: this.$t('from_agency'),
            value: 'from_agency_name',
            sortable: false,
          },
          ...this.headers,
        ]
    },
    profile(): User {
      return this.$store.getters.profile
    },
    table(): VueTable {
      return (this.$refs.table as VueTable[])[this.tabs]
    },
    total(): VueTotal {
      return (this.$refs.total as VueTotal[])[this.tabs]
    },
    getter(): (
      params?: Params,
    ) => Promise<AxiosResponse<Paginator<Remittance>>> {
      return (params?: Params) =>
        this.getGetter(getRemittances)({
          ...params,
          remittance__status__in: [
            'Draft',
            'Requested',
            'Assigned',
            'Distributing',
            'Delivered',
          ].join(','),
        })
    },
    totalsGetter(): (
      params?: Params,
    ) => Promise<AxiosResponse<Paginator<Remittance> | any>> {
      return (params?: Params) =>
        this.getGetter(remittanceTotals)({
          ...params,
          remittance__status__in: [
            'Draft',
            'Requested',
            'Assigned',
            'Distributing',
            'Delivered',
          ].join(','),
        })
    },
    yours(): boolean {
      return !this.tabs
    },
    tabOptions() {
      return [this.$t('yours'), this.$t('from_other_agencies')]
    },
  },
  watch: {
    allAmount(value: boolean) {
      const params = {} as { 'all-amount'?: boolean }
      if (value) {
        params['all-amount'] = true
      }
      this.total.newFilter({
        ...this.table.lastFilter,
        ...params,
      })
    },
  },
  methods: {
    getAgencies,
    getGetter(
      api: (
        params?: Params,
      ) => Promise<AxiosResponse<Paginator<Remittance> | any>>,
    ) {
      const newParams = {} as Params
      const getter = (params?: Params) => {
        if (['ADMIN', 'ACCOUNTANT'].includes(this.profile.role)) {
          if (params && !params.chain_type) {
            params.chain_type = 'AGENCY'
          }
          return api({
            chain_type: 'AGENCY',
            ...this.thisWeek,
            ...params,
          })
        } else return api(params)
      }
      if (['ADMIN', 'ACCOUNTANT'].includes(this.profile.role)) {
        if (!this.yours) {
          newParams.not_from_agency = this.profile.agency
        } else {
          newParams.from_agency__uuid = this.profile.agency
        }
      }
      return (params?: Params) =>
        getter({ ...this.thisWeek, ...params, ...newParams })
    },
    onNewFilter(params: Params) {
      const dates = (this.$refs.datePicker as DatePicker[])[this.tabs].getData()
      this.table.newFilter({
        ...params,
        created_at__gte: params.created_at__gte || dates.minDate,
        created_at__lte: params.created_at__lte || dates.maxDate,
        from_agency__uuid:
          params.from_agency__uuid || this.filter.from_agency__uuid,
      })
      const newParams = {} as { 'all-amount'?: boolean }
      if (this.allAmount) {
        newParams['all-amount'] = true
      }

      this.total.newFilter({
        ...params,
        created_at__gte: params.created_at__gte || dates.minDate,
        created_at__lte: params.created_at__lte || dates.maxDate,
        from_agency__uuid:
          params.from_agency__uuid || this.filter.from_agency__uuid,
        ...newParams,
      })
    },
    async downloadInvoicePDF(showCost?: boolean) {
      try {
        this.loadingInvoice = true
        const response = await getRemittanceInvoicePDF({
          ...this.table.lastFilter,
          'show-cost': showCost,
        })
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.download = 'invoices.pdf'
        link.click()
      } finally {
        this.loadingInvoice = false
      }
    },
    refresh() {
      this.newFilter(this.table.lastFilter)
      const params = {} as { 'all-amount'?: boolean }
      if (this.allAmount) {
        params['all-amount'] = true
      }
      this.total.newFilter({ ...this.table.lastFilter, ...params })
    },
    onFilterDate() {
      const dates = (this.$refs.datePicker as DatePicker[])[this.tabs].getData()
      this.table.newFilter({
        ...this.table.lastFilter,
        created_at__gte: dates.minDate,
        created_at__lte: dates.maxDate,
        ...this.filter,
      })
      const newParams = {} as { 'all-amount'?: boolean }
      if (this.allAmount) {
        newParams['all-amount'] = true
      }
      this.total.newFilter({
        created_at__gte: dates.minDate,
        created_at__lte: dates.maxDate,
        from_agency__uuid: this.filter.from_agency__uuid,
        ...newParams,
      })
    },
  },
})
